import { PlanningModeEnum } from "shared/enums/globalEnums";
import { GroupType } from "shared/types";
import { Choice } from "shared/utils/reactAdminHelpers";

export enum RampTestKey {
  RampTest1 = "rampTest1",
  RampTest2 = "rampTest2",
}

export enum JBoxTypeKey {
  JBox8Racks = "jbox8racks",
  JBox10Racks = "jbox10racks",
  JBox2 = "jbox2",
}

export enum DefaultAfrrChronicleFilenameEnum {
  R2Trial1 = "r2_essai_1.csv",
  R2Trial2 = "r2_essai_2.csv",
}

export enum GroupKey {
  PlanningsSocManagement = "plannings_soc_management",
  PlanningsAfrrPhase1 = "plannings_afrr_phase1",
  PlanningsAfrrPhase2 = "plannings_afrr_phase2",
}

export interface PlanningBase {
  mode: string;
  overridable: boolean;
}
export interface Planning extends PlanningBase {
  start_date: Date;
  end_date: Date;
}

export interface AfrrPlanning extends Planning {
  afrr_engagement_up: number;
  afrr_engagement_down: number;
  initial_soc_restoration_power: number;
  reactivity_delay: number;
}

export interface SocManagementPlanning extends Planning {
  target_soc: number;
}

/** UI config (unchanged shape elsewhere) */
export interface PlanningConfig {
  durationInMinutes: number;
  rampKey: RampTestKey | null;
  planningsKey: GroupKey;
  name?: string;
  testsParticipation?: string;
  duration?: number;
  mode?: PlanningModeEnum;
  role?: string;
  chronicle_filename?: string;
  overidable?: boolean;
  afrr_engagement?: number;
  target_soc?: number;
  initial_soc_restoration_power?: number;
  start_date?: string;
  end_date?: string;
}

export type JboxFormValues = Record<JBoxTypeKey, number | null>;

export interface SocManagementFormValues {
  /** SoC keeps its own toggle */
  active: boolean;
  target_soc: JboxFormValues;
  duration: number;
}

/** AFRR blocks no longer have their own toggles */
export interface AfrrFormValues {
  initial_soc_restoration_power: JboxFormValues;
  afrr_engagement_up: JboxFormValues;
  afrr_engagement_down: JboxFormValues;
  reactivity_delay: number;
}

export interface RampTestValues {
  /** shared toggle for both AFRR phases */
  afrr_active: boolean;
  /** SoC block with its own toggle */
  plannings_soc_management: SocManagementFormValues;
  /** the two AFRR phase blocks (no toggles inside) */
  plannings_afrr_phase1: AfrrFormValues;
  plannings_afrr_phase2: AfrrFormValues;
  /** dropdown (required if afrr_active is true) */
  chronicle_filename?: string;
}

export interface InitialFormValues {
  startingDate?: Date;
  group: GroupType;
  group_id?: number;
  rampTest1?: RampTestValues;
  rampTest2?: RampTestValues;
}

export interface IecConfigInfo {
  iecConfigChoices: Choice[];
  iecConfigsLoading: boolean;
  iecConfigsError: Error | null;
}

export type RampTestFormKeys =
  | "afrr_active"
  | "plannings_soc_management"
  | "plannings_afrr_phase1"
  | "plannings_afrr_phase2";

export type AfrrFormKeys =
  | "initial_soc_restoration_power"
  | "afrr_engagement_up"
  | "afrr_engagement_down"
  | "reactivity_delay";

export type SocManagementFormKeys = "active" | "target_soc" | "duration";

export type DefaultAfrrFormValues = Record<AfrrFormKeys, unknown>;
export type DefaultSocManagementFormValues = Record<SocManagementFormKeys, unknown>;

export type DefaultRampTestFormValues = Partial<
  Record<RampTestFormKeys, boolean | DefaultSocManagementFormValues | DefaultAfrrFormValues>
>;

export type DefaultFormValues = Record<RampTestKey, DefaultRampTestFormValues | null | undefined>;
